import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from './AppIcon';
import Button from './ui/Button';
import Image from './AppImage';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  
  const isHomePage = location?.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location?.pathname]);

  const navigationItems = [
    { path: '/', label: 'Главная', icon: 'Home' },
    { path: '/pricing-plans', label: 'Цены', icon: 'DollarSign' },
    { path: '/demo-playground#demo-chat', label: 'Демо', icon: 'Play' },
    { path: '/contact-support', label: 'Контакты', icon: 'MessageSquare' }
  ];

  const isActivePath = (path) => location?.pathname === path?.split('#')[0];

  return (
    <>
      <header 
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled 
            ? 'bg-background/95 backdrop-blur-lg shadow-lg' 
            : isHomePage 
              ? 'bg-white/10 backdrop-blur-md' :'bg-transparent'
        }`}
      >
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-16 lg:h-20">
            <Link 
              to="/" 
              className="flex items-center space-x-3 group"
            >
              <div className="w-10 h-10 lg:w-12 lg:h-12 rounded-xl flex items-center justify-center transition-all duration-300 group-hover:scale-105 group-hover:shadow-xl overflow-hidden bg-transparent">
                <Image 
                  src="/images/jetu-logo.webp" 
                  alt="Jetu AI" 
                  className="w-full h-full object-contain"
                />
              </div>
              <span className={`text-xl lg:text-2xl font-headline font-bold transition-colors ${
                isHomePage ? 'text-white' : 'text-foreground'
              }`}>
                Jetu AI
              </span>
            </Link>

            <nav className="hidden lg:flex items-center space-x-1">
              {navigationItems?.map((item) => (
                <Link
                  key={item?.path}
                  to={item?.path}
                  className={`px-4 py-2 rounded-lg font-medium transition-all duration-200 flex items-center space-x-2 ${
                    isActivePath(item?.path)
                      ? 'bg-accent text-accent-foreground shadow-sm'
                      : isHomePage
                        ? 'text-white hover:bg-white/10 hover:text-white' :'text-foreground hover:bg-muted hover:text-foreground'
                  }`}
                >
                  <Icon name={item?.icon} size={18} />
                  <span>{item?.label}</span>
                </Link>
              ))}
            </nav>

            <div className="hidden lg:flex items-center space-x-3">
              <Button 
                variant="ghost" 
                onClick={() => window.location.href = '/demo-playground#demo-chat'}
                className={isHomePage ? 'text-white hover:bg-white/10' : 'hover:bg-muted'}
              >
                Смотреть демо
              </Button>
            </div>

            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`lg:hidden p-2 rounded-lg transition-colors ${
                isHomePage 
                  ? 'hover:bg-white/10 text-white' :'hover:bg-muted text-foreground'
              }`}
              aria-label="Toggle mobile menu"
            >
              <Icon 
                name={isMobileMenuOpen ? 'X' : 'Menu'} 
                size={24} 
                color={isHomePage ? '#FFFFFF' : 'currentColor'}
              />
            </button>
          </div>
        </div>
      </header>
      {isMobileMenuOpen && (
        <div 
          className="fixed inset-0 z-40 lg:hidden"
          onClick={() => setIsMobileMenuOpen(false)}
        >
          <div className="absolute inset-0 bg-background/95 backdrop-blur-lg" />
          
          <nav 
            className="absolute top-20 left-0 right-0 bg-card border-t border-border shadow-xl animate-slide-up"
            onClick={(e) => e?.stopPropagation()}
          >
            <div className="container mx-auto px-4 py-6 space-y-2">
              {navigationItems?.map((item) => (
                <Link
                  key={item?.path}
                  to={item?.path}
                  className={`flex items-center space-x-3 px-4 py-3 rounded-lg font-medium transition-all duration-200 ${
                    isActivePath(item?.path)
                      ? 'bg-accent text-accent-foreground shadow-sm'
                      : 'text-foreground hover:bg-muted'
                  }`}
                >
                  <Icon name={item?.icon} size={20} />
                  <span>{item?.label}</span>
                </Link>
              ))}
              
              <div className="pt-4 space-y-2">
                <Button 
                  variant="outline" 
                  fullWidth
                  onClick={() => window.location.href = '/demo-playground#demo-chat'}
                >
                  Смотреть демо
                </Button>
              </div>
            </div>
          </nav>
        </div>
      )}
    </>
  );
};

export default Header;